import React from "react"
import Helmet from "react-helmet"
import { decode, truncate, stripTags } from "../../helpers/stringHelpers"

const SEOSettings = ({ entity, children }) => {
    const seoSettings = entity.seo
    // console.log(entity)
    const defaultDescription = `${truncate(stripTags(entity.content || ""), 200)}...`
    const title = seoSettings.title ? seoSettings.title : entity.title
    const metaDescription = seoSettings.metaDesc ? seoSettings.metaDesc : defaultDescription
    const metaKeywords = seoSettings.metaKeywords
    const metaRobotsNofollow = seoSettings.metaRobotsNofollow ? seoSettings.metaRobotsNofollow : null
    const metaRobotsNoindex = seoSettings.metaRobotsNoindex ? seoSettings.metaRobotsNoindex : null
    const opengraphTitle = seoSettings.opengraphTitle ? seoSettings.opengraphTitle : null
    const opengraphDescription = seoSettings.opengraphDescription ? seoSettings.opengraphDescription : null
    const opengraphImage = seoSettings.opengraphImage ? seoSettings.opengraphImage.srcUrl : null


    return (
        <Helmet>
            <meta charSet="utf-8" />
            <title>{title === "Homepage" ? `Derby Museums` : `${decode(title)} | Derby Museums`}</title>
            <meta name="description" content={decode(metaDescription)} />
            <meta name="keywords" content={decode(metaKeywords)} />
            <meta name="robots" content={`${metaRobotsNofollow},${metaRobotsNoindex}`} />

            <meta property="og:title" content={opengraphTitle} />
            <meta property="og:description" content={opengraphDescription} />
            <meta property="og:image" content={opengraphImage} />

            {children}
        </Helmet>
    )
}

export default SEOSettings
